import { useLayoutEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export default function CourseProgressStageLayout({ backUrl, children, className = "mx-auto max-w-6xl space-y-5", testId }) {
  const location = useLocation();

  useLayoutEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    const frameId = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    return () => {
      window.cancelAnimationFrame(frameId);
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, [location.key, location.pathname]);

  return (
    <div className={className} data-testid={testId}>
      <Link to={backUrl} state={{ focusCurrentStep: true }} className="inline-flex items-center gap-2 rounded-lg border border-[#183050] bg-white px-4 py-2.5 text-sm font-extrabold text-[#183050] shadow-sm transition hover:border-orange-500 hover:bg-orange-50 hover:text-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-300">
        <ArrowLeft className="h-4 w-4 stroke-[2.5]" /> Back to course progress
      </Link>
      {children}
    </div>
  );
}
